export default function removeIndex<T>(array: T[], index): T[] {
  const newArray = array.slice()
  newArray.splice(index, 1)
  return newArray
}
